import { CtImport } from '@/models/interfaces/content-type'
import { ContentType } from '@/services/directr'
import ContentModule from '@/utils/store'

export const model = {
    id: {
      field: 'id',
      label: 'ID',
      validator: () => true,
      type: 'string',
      required: true
    },
    refs: {
      field: 'refs',
      label: 'References',
      validator: () => true,
      type: 'array',
      required: false
    },
    type: {
      field: 'type',
      label: 'Content Type',
      validator: () => true,
      type: 'string',
      required: false
    },
    reference_field: {
      field: 'reference_field',
      label: 'Unique Reference Field',
      validator: () => true,
      type: 'string',
      required: false
    },
    status: {
      field: 'status',
      label: 'Status',
      validator: () => true,
      type: 'string',
      required: false
    }
  }

// specify actions etc. for orders using Directr
const state = {}
const getters = {}
const mutations = {}
const actions = {}

export default ContentModule<CtImport>(
  ContentType.Import, 'Services/Directr',
  model,
  state,
  getters,
  mutations,
  actions)
